import { Button, ButtonProps } from '@chakra-ui/react'
export type { ButtonProps }

export default Button
